export default __webpack_public_path__ + "static/stickies-59162041279b663c05c02dd274e24120.jpeg";